/* eslint-disable react/display-name*/
import {
  CircularProgress,
  IconButton,
  Tooltip,
  Typography,
  Grid,
} from "@mui/material";
import RefreshIcon from "@mui/icons-material/Refresh";

import PDialog from "../../../components/pos/PDialog";
import db from "../../../db/db";
import MUIDataTable from "mui-datatables";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import API from "../../../utils/API";

export default function CustomertransactionList(props) {
  const { t } = useTranslation();
  const translate = t;
  const [data, setData] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitle] = useState(
    translate("Customer Transactions")
  );
  const [id, setId] = useState("");
  const [name, setName] = useState("");

  const [searchStr, setSearchStr] = useState("");

  useEffect(() => {}, []);

  props.biRef.transactions = {
    showTransactionList: showTransactionList,
  };

  function showTransactionList(custId, name) {
    setOpenWindow(true);
    setId(id);
    setName(name);
    loadData(custId);
  }
  function onCloseWindow() {
    setOpenWindow(false);
  }

  /*function addCustomertransaction() {
    biRef.child.showCustomertransactionCrudWindow(null);
  }

  function onEditClicked(row) {
    biRef.child.showCustomertransactionCrudWindow(row.tableData[row.rowIndex].id);
  }*/

  async function loadData(id) {
    loadByRest(id, 0, 10, "[]", "[]");
    //loaadByDB();
  }
  async function loadByRest(id, curPage, pageSize, sort, filter) {
    console.log("Load by rest");
    setIsLoading(true);
    const result = await API.get(
      "/api/v1/customer/transactions/" +
        id +
        "?range=" +
        encodeURIComponent(
          "[" + curPage * pageSize + "," + ((curPage + 1) * pageSize - 1) + "]"
        ) +
        "&filter=" +
        encodeURIComponent(filter) +
        "&sort=" +
        encodeURIComponent(sort)
    );
    console.log(JSON.stringify(result));

    var arr = result.headers["content-range"].split("/");

    const opt = { ...option };
    opt.count = parseInt(arr[2]);
    setOption(opt);
    setData(result.data);
    setIsLoading(false);
  }

  async function loaadByDB() {
    db.customertransaction.toArray(function (data) {
      setData(data);
    });
  }

  async function onTableChange(tableState) {
    console.log(tableState.sortOrder);
    let sort = "[]";
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    if (tableState.sortOrder.name) {
      sort =
        '[{id:"' +
        tableState.sortOrder.name +
        '",desc:' +
        (tableState.sortOrder.direction === "desc" ? "true}]" : "false}]");
    }
    let search = "[]";
    if (tableState.searchText) {
      let str = "[";
      str = str + '{id:"name",value:"' + tableState.searchText + '"}';
      str = str + ',{id:"code",value:"' + tableState.searchText + '"}';

      str = str + "]";
      search = str;
    }
    loadByRest(id, tableState.page, tableState.rowsPerPage, sort, search);
  }

  const options = {
    serverSide: true,
    filterType: "dropdown",
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    tableBodyHeight: "350px",

    print: false,
    onTableChange: (action, tableState) => {
      // a developer could react to change on an action basis or
      // examine the state as a whole and do whatever they want

      switch (action) {
        case "changePage":
          onTableChange(tableState);
          break;
        case "sort":
          onTableChange(tableState);
          break;
        case "changeRowsPerPage":
          onTableChange(tableState);
          break;
        case "search":
          onTableChange(tableState);
          break;
        default:
        //console.log("action not handled." + action);
      }
    },
    customToolbar: () => {
      return (
        <React.Fragment>
          <Tooltip title={translate("Refresh Data")}>
            <IconButton
              size="small"
              color="primary"
              onClick={customertransactionListRefresh}
            >
              <RefreshIcon />
            </IconButton>
          </Tooltip>
        </React.Fragment>
      );
    },
  };

  const [option, setOption] = useState(options);

  const columns = [
    {
      name: "transactionDate",
      label: translate("Date"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "code",
      label: translate("Voucher Number"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "transactionType",
      label: translate("Type"),
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "val",
      label: translate("Credit Amount"),
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (dataIndex) => {
          let val =
            data[dataIndex].paymentMode == "CREDIT"
              ? ""
              : data[dataIndex].amount;
          return val;
        },
      },
    },
    {
      name: "val",
      label: translate("Debit Amount"),
      options: {
        filter: false,
        sort: true,
        customBodyRenderLite: (dataIndex) => {
          let val =
            data[dataIndex].paymentMode == "CREDIT"
              ? data[dataIndex].amount
              : "";
          return val;
        },
      },
    },
    {
      name: "paymentMode",
      label: translate("Mode"),
      options: {
        filter: true,
        sort: true,
      },
    },
    {
      name: "currentDue",
      label: translate("Balance"),
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: "description",
      label: translate("Description"),
      options: {
        filter: false,
        sort: true,
      },
    },
    /* {
      name: "action",
      label: "Actions",
      options: {
        /*
        filter: false,
        sort: false,
        display: "true",
        setCellHeaderProps: () => ({ align: "right" }),
        setCellProps: () => ({ align: "right" }),
        customBodyRender: (value, tableMeta, updateValue) => (
          <Button
            onClick={() => onEditClicked(tableMeta, updateValue, value)}
            color="secondary"
            style={ {
              margin: 0,
              padding: 0,
              height: 17,
              width: 27,
              alignText: "right",
            } }
          >
            Edit
          </Button>
        ),
          
      },
    },*/
  ];
  const content = (
    <Grid container>
      <Grid item xs={12}>
        <div>
          <MUIDataTable
            title={
              <Typography variant="h6">
                {name + " Transactions"}
                {isLoading && (
                  <CircularProgress
                    size={24}
                    style={{ marginLeft: 15, position: "relative", top: 4 }}
                  />
                )}
              </Typography>
            }
            data={data}
            columns={columns}
            options={option}
          />
        </div>
      </Grid>
      {/*<CustomertransactionCrud
      biRef={biRef}
      showMessage={props.showMessage}
      onRefresh={customertransactionListRefresh}
    ></CustomertransactionCrud>*/}
      {/**/}
    </Grid>
  );

  function customertransactionListRefresh() {
    loadData();
  }

  var biRef = {};

  return (
    <div>
      {openWindow && (
        <PDialog
          style={{ height: 650 }}
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={true}
          onCloseWindow={onCloseWindow}
          hideSave={true}
        ></PDialog>
      )}
    </div>
  );
}
